import { Buffer } from 'buffer';

const { localStorage } = window;
// Par défaut 10 min
const expiration = (window._CONFIGS && window._CONFIGS.expiration) || (20 * 60000) ;

function b64e(str) {
  if (str) return Buffer.from(str).toString('base64');
}

function b64d(str) {
  return Buffer.from(str, 'base64').toString();
}

Storage.prototype.setObjectHash = function(key, myObject) {
	this.setItem(key, b64e(JSON.stringify(myObject)));
}

Storage.prototype.getObjectHash = function(key) {
	const svalue = this.getItem(key);
    if (svalue) {
      return JSON.parse(b64d(svalue));
    }
}

function refreshTime(ttl) {
  const item = localStorage.getObjectHash('data') || { };
  const now = new Date();
  item.temp = now.getTime() + ttl;
  localStorage.setObjectHash('data', item);
}


function setWithExpiry(key, value, ttl) {
  const item = localStorage.getObjectHash('data') || { };
  const now = new Date();
  item.temp = now.getTime() + ttl;
  item[key] = value
  localStorage.setObjectHash('data', item);
}

function getWithExpiry(key, ttl) {
  const item = localStorage.getObjectHash('data')
  // if the item doesn't exist, return null
  if (!item) {
    return null
  }
  const value = item[key];
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.temp) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem('data')
    return null
  }

  // actualisation du temps restant après chaque interrogation
  localStorage.setObjectHash('data', item);
  return value
}


export function refresh() {
  refreshTime(expiration);
}

export function setAuthToken(newToken) {
  setWithExpiry('token', newToken, expiration);
}
export function setLoggedUser(user) {
  setWithExpiry('user', user, expiration);
}

export function clear() {
  setAuthToken('');
  setLoggedUser({});
}

export function getAuthToken() {
  return  getWithExpiry('token', expiration) || '';
}
export function getUser() {
  return getWithExpiry('user', expiration) || {};
}

export function isLogged(){
  return !!getAuthToken();
}

export function getExpiration(){
    const item = localStorage.getObjectHash('data')
    // if the item doesn't exist, return null
    if (!item) {
      return {
        expire: null,
        ttl: 0
      };
    }
    return {
      expire: item.temp,
      ttl: now.getTime() - item.temp
    };
}

/**
 * Synchronisation de l'expiration du stockage du token avec le serveur
 * @param {time} at date d'expiration du token sur le serveur
 * @returns 
 */
export function setExpiration(at){
  if ( at){
    const now = new Date(); 
    const ttl = (new Date(Number(at)) - now );
    refreshTime(ttl)
    // On demande de forcer le refresh sur le serveur si moins d'une minute
    return (ttl < 60);
  }
  return false;
}
